module.exports = __webpack_public_path__ + "img/ogp_dreamocean_big.fbefcbd8.jpg";